var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 40 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9768 53.8641L4.39275 49.5378L0.919922 10.5859H39.0804L35.6039 49.5317L19.9768 53.8641Z",
    fill: "#912F48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6274 47.0505L35.5983 13.7695H20V50.5513L32.6274 47.0505Z",
    fill: "#B42F53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88086 28.2168L9.30903 32.994H19.9997V28.2168H8.88086Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02051 18.5469L8.45478 23.3242H19.9997V18.5469H8.02051Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 40.624L19.9787 40.6296L14.6582 39.1929L14.3181 35.3828H9.52246L10.1918 42.8838L19.9777 45.6005L19.9997 45.5944V40.624Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0881 28.2162L31.9506 18.5469H19.9834V23.3242H26.7151L26.2804 28.2162H19.9834V32.9935H25.8661L25.3116 39.1892L19.9834 40.6274V45.5975L29.7771 42.8832L29.849 42.0761L30.9716 29.4991L31.0881 28.2162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.1d7a79ece6215a221fcf093714c603fb.svg";
export { ForwardRef as ReactComponent };